export default __webpack_public_path__ + "static/realWorldImg4-24ac9737d78509d2ccf93ba89fd01614.webp";